export default __webpack_public_path__ + "static/media/01-SunshineDonut.04b01727.png";